/* eslint-disable */
export default {
  all: 'All',
  company: 'Company',
  personal: 'Personal',
} as const;

// @key: @#@"all"@#@ @source: @#@"All"@#@
// @key: @#@"company"@#@ @source: @#@"Company"@#@
// @key: @#@"personal"@#@ @source: @#@"Personal"@#@
